import { createTranslations } from '@npco/common-utils-translations'

export const interestEarningStageTranslations = createTranslations({
  title: 'Grow your business savings',
  description:
    'Zeller Savings Account is an interest-earning account, so your money saved generates a return for your business immediately. Interest earned is calculated daily, and paid monthly.',
})
